/* eslint-disable import/no-anonymous-default-export */
import Cookies from "js-cookie";
import { Action } from "../../../domain/entities/ActionModel";
import { SignatoryState, StateStatus } from "../../../domain/entities/State";
import { ActionTypes } from "../actions/signatory";

const initialState: SignatoryState = {
  documentsLoadStatus: StateStatus.INIT,
  documents: null,
  documentsLoadError: null,
  documentLoadStatus: StateStatus.INIT,
  document: null,
  documentLoadError: null,
  documentSaveStatus: StateStatus.INIT,
  documentSaveError: null,
  signedDocument: null,
  documentSignStatus: StateStatus.INIT,
  documentSignError: null,
  documentSendStatus: StateStatus.INIT,
  documentSendError: null,
  documentSendBackStatus: StateStatus.INIT,
  documentSendBackError: null,
  documentSaveProgressStatus: StateStatus.INIT,
  documentSaveProgressError: null,
  signatoryLoadStatus: StateStatus.INIT,
  signatory: null,
  signatoryLoadError: null,
  signatorySaveStatus: StateStatus.INIT,
  signatorySaveError: null,
  pdfTranslateStatus: StateStatus.INIT,
  pdfTranslated: null,
  pdfTranslateError: null,
  chatSaveStatus: StateStatus.INIT,
  chat: null,
  chatSaveError: null,
  chatDeleteStatus: StateStatus.INIT,
  chatDeleteError: null,
  chatsLoadStatus: StateStatus.INIT,
  chats: null,
  chatsLoadError: null,
  collectiveSelectedSignatory: undefined,
  collectiveDocuments: null,
  collectiveMessages: null,
  collectiveData: null,
  paymentSaveStatus: StateStatus.INIT,
  paymentSaveError: null,
  paymentLoadStatus: StateStatus.INIT,
  payment: null,
  paymentLoadError: null,
  paymentsLoadStatus: StateStatus.INIT,
  payments: null,
  paymentsLoadError: null,
  paymentsCountLoadStatus: StateStatus.INIT,
  paymentsCount: null,
  paymentsCountLoadError: null,
  pdfESignLoadStatus: StateStatus.INIT,
  pdfESign: null,
  pdfESignSummary: null,
  pdfESignLoadError: null,
  lastEvaluatedKey: undefined,
  attachmentPDFSaveStatus: StateStatus.INIT,
  attachmentPDFSaveError: null,
  attachmentPDFLoadStatus: StateStatus.INIT,
  attachmentPDF: null,
  attachmentPDFLoadError: null,
};

export default (state = initialState, action: Action<any>): SignatoryState => {
  switch (action.type) {
    case ActionTypes.DOCUMENTS_RESTORE_STATES: {
      return {
        ...state,
        documentSaveStatus: StateStatus.INIT,
        documentLoadStatus: StateStatus.INIT,
        documentsLoadStatus: StateStatus.INIT,
      };
    }
    case ActionTypes.DOCUMENT_CLEAN_VALUE: {
      return {
        ...state,
        document: null,
      };
    }
    case ActionTypes.DOCUMENTS_CLEAN_VALUE: {
      return {
        ...state,
        documents: null,
      };
    }
    case ActionTypes.DOCUMENT_SAVE_COMPLETE: {
      return {
        ...state,
        documentSaveStatus: StateStatus.COMPLETE,
        documentSaveError: null,
      };
    }
    case ActionTypes.DOCUMENT_SAVE_ERROR: {
      return {
        ...state,
        documentSaveStatus: StateStatus.ERROR,
        documentSaveError: action.payload,
      };
    }
    case ActionTypes.DOCUMENT_SAVE_PROCESSING: {
      return {
        ...state,
        documentSaveStatus: StateStatus.LOADING,
      };
    }
    case ActionTypes.DOCUMENTS_LOAD_COMPLETE: {
      return {
        ...state,
        documentsLoadStatus: StateStatus.COMPLETE,
        documents: action.payload,
        documentsLoadError: null,
      };
    }
    case ActionTypes.DOCUMENTS_LOAD_ERROR: {
      return {
        ...state,
        documentsLoadStatus: StateStatus.ERROR,
        documentsLoadError: action.payload,
      };
    }
    case ActionTypes.DOCUMENTS_LOAD_PROCESSING: {
      return {
        ...state,
        documentsLoadStatus: StateStatus.LOADING,
      };
    }
    case ActionTypes.DOCUMENT_LOAD_COMPLETE: {
      return {
        ...state,
        documentLoadStatus: StateStatus.COMPLETE,
        document: action.payload,
        signedDocument: null,
        documentLoadError: null,
      };
    }
    case ActionTypes.DOCUMENT_LOAD_ERROR: {
      return {
        ...state,
        documentLoadStatus: StateStatus.ERROR,
        documentLoadError: action.payload,
      };
    }
    case ActionTypes.DOCUMENT_LOAD_PROCESSING: {
      return {
        ...state,
        documentLoadStatus: StateStatus.LOADING,
      };
    }
    case ActionTypes.DOCUMENT_SIGN_COMPLETE: {
      return {
        ...state,
        documentSignStatus: StateStatus.COMPLETE,
        documentSignError: null,
      };
    }
    case ActionTypes.DOCUMENT_SIGN_ERROR: {
      return {
        ...state,
        documentSignStatus: StateStatus.ERROR,
        documentSignError: action.payload,
      };
    }
    case ActionTypes.DOCUMENT_SIGN_PROCESSING: {
      return {
        ...state,
        documentSignStatus: StateStatus.LOADING,
      };
    }
    case ActionTypes.DOCUMENT_RESEND_COMPLETE: {
      return {
        ...state,
        documentSendStatus: StateStatus.COMPLETE,
        documentSendError: null,
      };
    }
    case ActionTypes.DOCUMENT_RESEND_ERROR: {
      return {
        ...state,
        documentSendStatus: StateStatus.ERROR,
        documentSendError: action.payload,
      };
    }
    case ActionTypes.DOCUMENT_RESEND_PROCESSING: {
      return {
        ...state,
        documentSendStatus: StateStatus.LOADING,
      };
    }
    case ActionTypes.DOCUMENT_SENDBACK_COMPLETE: {
      return {
        ...state,
        documentSendBackStatus: StateStatus.COMPLETE,
        documentSendBackError: null,
      };
    }
    case ActionTypes.DOCUMENT_SENDBACK_ERROR: {
      return {
        ...state,
        documentSendBackStatus: StateStatus.ERROR,
        documentSendBackError: action.payload,
      };
    }
    case ActionTypes.DOCUMENT_SENDBACK_PROCESSING: {
      return {
        ...state,
        documentSendBackStatus: StateStatus.LOADING,
      };
    }
    case ActionTypes.DOCUMENT_SAVE_PROGRESS_COMPLETE: {
      return {
        ...state,
        documentSaveProgressStatus: StateStatus.COMPLETE,
        documentSaveProgressError: null,
      };
    }
    case ActionTypes.DOCUMENT_SAVE_PROGRESS_ERROR: {
      return {
        ...state,
        documentSaveProgressStatus: StateStatus.ERROR,
        documentSaveProgressError: action.payload,
      };
    }
    case ActionTypes.DOCUMENT_SAVE_PROGRESS_PROCESSING: {
      return {
        ...state,
        documentSaveProgressStatus: StateStatus.LOADING,
      };
    }
    case ActionTypes.SIGNATORY_SAVE_COMPLETE: {
      return {
        ...state,
        signatorySaveStatus: StateStatus.COMPLETE,
        signatorySaveError: null,
      };
    }
    case ActionTypes.SIGNATORY_SAVE_ERROR: {
      return {
        ...state,
        signatorySaveStatus: StateStatus.ERROR,
        signatorySaveError: action.payload,
      };
    }
    case ActionTypes.SIGNATORY_SAVE_PROCESSING: {
      return {
        ...state,
        signatorySaveStatus: StateStatus.LOADING,
      };
    }
    case ActionTypes.SIGNATORY_LOAD_BY_EMAIL_COMPLETE: {
      console.log("SIGNATORY_LOAD_BY_EMAIL_COMPLETE", action.payload);
      //if password is correct, return different status
      return {
        ...state,
        signatoryLoadStatus: StateStatus.COMPLETE,
        signatory: action.payload,
        //pinValidationStatus: true,
      };
    }
    case ActionTypes.SIGNATORY_LOAD_BY_EMAIL_ERROR: {
      return {
        ...state,
        signatoryLoadStatus: StateStatus.ERROR,
        signatoryLoadError: action.payload,
      };
    }
    case ActionTypes.SIGNATORY_LOAD_BY_EMAIL_PROCESSING: {
      return {
        ...state,
        signatoryLoadStatus: StateStatus.LOADING,
      };
    }
    case ActionTypes.SIGNATORY_AUTH_LOAD_BY_EMAIL_COMPLETE: {
      console.log("SIGNATORY_AUTH_LOAD_BY_EMAIL_COMPLETE", action.payload);

      if (!action.payload) {
        return {
          ...state,
          signatoryLoadStatus: StateStatus.ERROR,
          signatoryLoadError: "Invalid or expired code",
        };
      }

      const { IdToken, signatory } = action.payload;

      if (IdToken) {
        Cookies.set("id_token", IdToken, {
          expires: 1,
          secure: true,
          sameSite: "Strict",
        });

        return {
          ...state,
          signatoryLoadStatus: StateStatus.COMPLETE,
          signatory,
          signatoryLoadError: null,
        };
      } else {
        return {
          ...state,
          signatoryLoadStatus: StateStatus.ERROR,
          signatoryLoadError: "No token received",
        };
      }
    }
    case ActionTypes.SIGNATORY_AUTH_LOAD_BY_EMAIL_ERROR: {
      return {
        ...state,
        signatoryLoadStatus: StateStatus.ERROR,
        signatoryLoadError: action.payload,
      };
    }
    case ActionTypes.SIGNATORY_AUTH_LOAD_BY_EMAIL_PROCESSING: {
      return {
        ...state,
        signatoryLoadStatus: StateStatus.LOADING,
      };
    }
    case ActionTypes.PDF_TRANSLATE_COMPLETE: {
      return {
        ...state,
        pdfTranslateStatus: StateStatus.COMPLETE,
        pdfTranslated: action.payload,
      };
    }
    case ActionTypes.PDF_TRANSLATE_ERROR: {
      return {
        ...state,
        pdfTranslateStatus: StateStatus.ERROR,
        pdfTranslateError: action.payload,
      };
    }
    case ActionTypes.PDF_TRANSLATE_PROCESSING: {
      return {
        ...state,
        pdfTranslateStatus: StateStatus.LOADING,
      };
    }
    case ActionTypes.CHAT_SAVE_COMPLETE: {
      return {
        ...state,
        chatSaveStatus: StateStatus.COMPLETE,
        chatSaveError: null,
      };
    }
    case ActionTypes.CHAT_SAVE_ERROR: {
      return {
        ...state,
        chatSaveStatus: StateStatus.ERROR,
        chatSaveError: action.payload,
      };
    }
    case ActionTypes.CHAT_SAVE_PROCESSING: {
      return {
        ...state,
        chatSaveStatus: StateStatus.LOADING,
      };
    }
    case ActionTypes.CHATS_LOAD_COMPLETE: {
      return {
        ...state,
        chatsLoadStatus: StateStatus.COMPLETE,
        chats: action.payload,
        chatsLoadError: null,
      };
    }
    case ActionTypes.CHATS_LOAD_ERROR: {
      return {
        ...state,
        chatsLoadStatus: StateStatus.ERROR,
        chatsLoadError: action.payload,
      };
    }
    case ActionTypes.CHATS_LOAD_PROCESSING: {
      return {
        ...state,
        chatsLoadStatus: StateStatus.LOADING,
      };
    }
    case ActionTypes.CHAT_DELETE_COMPLETE: {
      return {
        ...state,
        chatDeleteStatus: StateStatus.COMPLETE,
        chatDeleteError: null,
      };
    }
    case ActionTypes.CHAT_DELETE_ERROR: {
      return {
        ...state,
        chatDeleteStatus: StateStatus.ERROR,
        chatDeleteError: action.payload,
      };
    }
    case ActionTypes.CHAT_DELETE_PROCESSING: {
      return {
        ...state,
        chatDeleteStatus: StateStatus.LOADING,
      };
    }
    case ActionTypes.COLLECTIVE_SIGNATORY_UPDATE: {
      return {
        ...state,
        collectiveSelectedSignatory: action.payload,
      };
    }
    case ActionTypes.COLLECTIVE_DOCUMENTS_UPDATE: {
      return {
        ...state,
        collectiveDocuments: action.payload,
      };
    }
    case ActionTypes.COLLECTIVE_MESSAGES_UPDATE: {
      return {
        ...state,
        collectiveMessages: action.payload,
      };
    }
    case ActionTypes.COLLECTIVE_DATA_UPDATE: {
      return {
        ...state,
        collectiveData: action.payload,
      };
    }
    case ActionTypes.PAYMENTS_CLEAN_VALUE: {
      return {
        ...state,
        payments: [],
      };
    }
    case ActionTypes.PAYMENT_SAVE_COMPLETE: {
      return {
        ...state,
        paymentSaveStatus: StateStatus.COMPLETE,
        paymentSaveError: null,
      };
    }
    case ActionTypes.PAYMENT_SAVE_ERROR: {
      return {
        ...state,
        paymentSaveStatus: StateStatus.ERROR,
        paymentSaveError: action.payload,
      };
    }
    case ActionTypes.PAYMENT_SAVE_PROCESSING: {
      return {
        ...state,
        paymentSaveStatus: StateStatus.LOADING,
      };
    }
    case ActionTypes.PAYMENT_LOAD_COMPLETE: {
      return {
        ...state,
        paymentLoadStatus: StateStatus.COMPLETE,
        payment: action.payload,
        paymentLoadError: null,
      };
    }
    case ActionTypes.PAYMENT_LOAD_ERROR: {
      return {
        ...state,
        paymentLoadStatus: StateStatus.ERROR,
        paymentLoadError: action.payload,
      };
    }
    case ActionTypes.PAYMENT_LOAD_PROCESSING: {
      return {
        ...state,
        paymentLoadStatus: StateStatus.LOADING,
      };
    }
    case ActionTypes.PAYMENTS_LOAD_COMPLETE: {
      return {
        ...state,
        paymentsLoadStatus: StateStatus.COMPLETE,
        payments: action.payload,
        paymentsLoadError: null,
      };
    }
    case ActionTypes.PAYMENTS_LOAD_ERROR: {
      return {
        ...state,
        paymentsLoadStatus: StateStatus.ERROR,
        paymentsLoadError: action.payload,
      };
    }
    case ActionTypes.PAYMENTS_LOAD_PROCESSING: {
      return {
        ...state,
        paymentsLoadStatus: StateStatus.LOADING,
      };
    }
    case ActionTypes.PAYMENTS_COUNT_CLEAN: {
      return {
        ...state,
        paymentsCount: null,
      };
    }
    case ActionTypes.PAYMENTS_RESTORE_STATES: {
      return {
        ...state,
        paymentsLoadStatus: StateStatus.INIT,
      };
    }
    case ActionTypes.PAYMENTS_COUNT_LOAD_COMPLETE: {
      return {
        ...state,
        paymentsCountLoadStatus: StateStatus.COMPLETE,
        paymentsCount: action.payload,
        paymentsCountLoadError: null,
      };
    }
    case ActionTypes.PAYMENTS_COUNT_LOAD_ERROR: {
      return {
        ...state,
        paymentsCountLoadStatus: StateStatus.ERROR,
        paymentsCountLoadError: action.payload,
      };
    }
    case ActionTypes.PAYMENTS_COUNT_LOAD_PROCESSING: {
      return {
        ...state,
        paymentsCountLoadStatus: StateStatus.LOADING,
      };
    }
    case ActionTypes.PAYMENTS_PAGINATION_LOAD_COMPLETE: {
      const existingPayIds = new Set((state.payments || []).map((p: any) => p.id));
      const newPays = action.payload.items.filter((p: any) => !existingPayIds.has(p.id));
      return {
        ...state,
        paymentsLoadStatus: StateStatus.COMPLETE,
        payments: [...(state.payments || []), ...newPays],
        lastEvaluatedKey: action.payload.lastEvaluatedKey  || null,
        paymentsLoadError: null,
      };
    }    
    case ActionTypes.PAYMENTS_PAGINATION_LOAD_ERROR: {
      return {
        ...state,
        paymentsLoadStatus: StateStatus.ERROR,
        paymentsLoadError: action.payload,
      };
    }
    case ActionTypes.PAYMENTS_PAGINATION_LOAD_PROCESSING: {
      return {
        ...state,
        paymentsLoadStatus: StateStatus.LOADING,
      };
    }
    case ActionTypes.LASTVALUEKEY_CLEAN: {
      return {
        ...state,
        lastEvaluatedKey: undefined,
      };
    }
    case ActionTypes.PAYMENT_SUCCESS_COMPLETE: {
      return {
        ...state,
        paymentLoadStatus: StateStatus.COMPLETE,
        payment: action.payload,
        paymentLoadError: null,
      };
    }
    case ActionTypes.PAYMENT_SUCCESS_ERROR: {
      return {
        ...state,
        paymentLoadStatus: StateStatus.ERROR,
        paymentLoadError: action.payload,
      };
    }
    case ActionTypes.PAYMENT_SUCCESS_PROCESSING: {
      return {
        ...state,
        paymentLoadStatus: StateStatus.LOADING,
      };
    }
    case ActionTypes.PDF_ESIGN_COMPLETE: {
      return {
        ...state,
        pdfESignLoadStatus: StateStatus.COMPLETE,
        pdfESign: action.payload,
        pdfESignSummary: null,
        pdfESignLoadError: null,
      };
    }
    case ActionTypes.PDF_ESIGN_AUDIT_COMPLETE: {
      return {
        ...state,
        pdfESignLoadStatus: StateStatus.COMPLETE,
        pdfESign: action.payload.signedDocumentPdf,
        pdfESignSummary: action.payload.auditSummaryPdf,
        pdfESignLoadError: null,
      };
    }
    case ActionTypes.PDF_ESIGN_ERROR: {
      return {
        ...state,
        pdfESignLoadStatus: StateStatus.ERROR,
        pdfESignLoadError: action.payload,
      };
    }
    case ActionTypes.PDF_ESIGN_PROCESSING: {
      return {
        ...state,
        pdfESignLoadStatus: StateStatus.LOADING,
      };
    }
    case ActionTypes.ATTACHMENT_SAVE_COMPLETE: {
      return {
        ...state,
        attachmentPDFSaveStatus: StateStatus.COMPLETE,
        attachmentPDFSaveError: null,
      };
    }
    case ActionTypes.ATTACHMENT_SAVE_ERROR: {
      return {
        ...state,
        attachmentPDFSaveStatus: StateStatus.ERROR,
        attachmentPDFSaveError: action.payload,
      };
    }
    case ActionTypes.ATTACHMENT_SAVE_PROCESSING: {
      return {
        ...state,
        attachmentPDFSaveStatus: StateStatus.LOADING,
      };
    }
    case ActionTypes.ATTACHMENT_LOAD_COMPLETE: {
      return {
        ...state,
        attachmentPDFLoadStatus: StateStatus.COMPLETE,
        attachmentPDF: action.payload,
        attachmentPDFLoadError: null,
      };
    }
    case ActionTypes.ATTACHMENT_LOAD_ERROR: {
      return {
        ...state,
        attachmentPDFLoadStatus: StateStatus.ERROR,
        attachmentPDFLoadError: action.payload,
      };
    }
    case ActionTypes.ATTACHMENT_LOAD_PROCESSING: {
      return {
        ...state,
        attachmentPDFLoadStatus: StateStatus.LOADING,
      };
    }
    default:
      return state;
  }
};
